import { DefaultTranslations, TranslationDictionary } from '../../idscan/configuration/TranslationDictionary';
import { TranslationKey } from '../../idscan/enums/Translation';

/**
 * Function which accepts a key, language and props to produce a translated
 * string
 *
 * @public
 */
export type Translator = (key: TranslationKey, language: string, props: Record<string, any>) => string;

/**
 * @public
 */
export class LanguageService {

	private _language: string = 'en_GB';
	private _dictionary: TranslationDictionary = DefaultTranslations;
	private _translator: Translator = this.defaultTranslator;

	public get dictionary(): TranslationDictionary {
		return { ...this._dictionary };
	}

	public setLanguage = (language?: string) => this._language = language ? language : this._language;
	public setTranslator = (translator?: Translator) => this._translator = translator ? translator : this._translator;
	public setDictionary = (dictionary?: Partial<TranslationDictionary>) => this._dictionary = { ...this._dictionary, ...dictionary };

	public getTranslation = (key: TranslationKey, props: Record<string, any> = {}) => {
		const translation = this._translator(key, this._language, props);
		return typeof translation !== 'undefined' ? translation : '__NO_TRANSLATION__';
	}

	private defaultTranslator(key: TranslationKey, language: string = this._language, props: Record<string, any> = {}) {
		return this.dictionary[key];
	}

}

export default new LanguageService();
